import React, { Component } from 'react';
import Divider from '@material-ui/core/Divider';
import {generateVideo, generateImage, generateStandAloneLink, generateText} from '../common/dynamic/DynamicConentGeneratorFunctions';
import {disclaimerTextStyle} from '../../styles/shared/variables';
import {dividerStyle} from './styles/desktop';

class Project extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        return (
            <div id='project-information-main-container'>
                {this.renderSubTitle()}
                {this.generateProjectData()}
            </div>
        )

    }

    renderSubTitle(projectData) {
        if (this.props.projectData.projectSubTitle) {
            return <div id='project-title-and-subtitle-container' style={{ textAlign: 'center' }}>
                <span id='project-subtitle-span' style={disclaimerTextStyle}>{this.props.projectData.projectSubTitle}</span>
                <Divider style={dividerStyle}/>
            </div>
        }
    }
    generateProjectData() {
        if (this.props.projectData.contents != null && this.props.projectData.contents.length > 0) {
            return this.props.projectData.contents.map(function (contentItem, index) {
                if (contentItem.contentType.toLowerCase() === 'text') {
                    return generateText(contentItem.content, index);
                }
                else if (contentItem.contentType.toLowerCase() === 'image') {
                    return generateImage(contentItem.content, index, this.props.projectData.referenceFiles);
                } else if (contentItem.contentType.toLowerCase() === 'standalonelink') {
                    return generateStandAloneLink(contentItem.content, index, this.props.projectData.referenceFiles);
                } else if (contentItem.contentType.toLowerCase() === 'video') {
                    return generateVideo(contentItem.content, index, this.props.projectData.referenceFiles)
                } else {
                    return generateText(contentItem.content, index);

                }
            }, this);
        }
    }
}

export default Project;


// WEBPACK FOOTER //
// ./src/components/projects/Project.js